import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import ArrowRight from "../../assets/arrowRight";
import { useModal } from "../../hooks/useModal";
import { useNavigate } from "react-router";
import CreateNumber from "../../component/createNumber";
import ImportContacts from "../../component/importContacts";
import CheckIcon from "../../assets/checkIcon";

type checkList = {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonAction?: () => void;
  status?: boolean;
  isDone?: boolean;
};

export default function OnboardingScreen({ profile }) {
  const { openModal } = useModal();
  const navigate = useNavigate();

  console.log(profile);

  const checklist: checkList[] = [
    {
      title: "Import your contacts",
      subtitle: "Sync from CRM, Sheets, or CSV upload",
      buttonText: "Import contacts",
      buttonAction: () => {
        openModal({ view: <ImportContacts /> });
      },
      status: true,
      isDone: profile?.is_contact_import,
    },
    {
      title: "Create a Segment",
      subtitle: "Group contacts for outreach ( e.g. industry, intent)",
      buttonText: "Create segment",
      buttonAction: () => {},
      status: profile?.is_contact_import,
      isDone: profile?.is_segment_created,
    },
    {
      title: "Buy a Phone Number",
      subtitle: "Needed to make calls. comes with $10 call credit",
      buttonText: "Buy now",
      buttonAction: () => {
        openModal({ view: <CreateNumber /> });
      },
      status: profile?.is_segment_created,
      isDone: profile?.is_has_phone_number,
    },
    {
      title: "Launch Your First Campaign",
      subtitle: "Start reaching out to lead instantly with your AI Agent",
      buttonText: "Create campaign",
      buttonAction: () => {
        navigate("/campaigns/new");
      },
      status: profile?.is_has_phone_number,
      isDone: profile?.is_campaign_launched,
    },
  ];
  return (
    <div className="mx-auto md:w-[641px] h-[429px] w-[95%] my-auto">
      <div
        style={{ backgroundImage: "url(/onboarding.png)" }}
        className="bg-btn flex flex-col gap-[12px] h-[96px] rounded-t-[4px] justify-center px-[16px] sm:px-[24px] bg-no-repeat bg-[97%_bottom]"
      >
        <Text className="font-ibmPlexSerif text-background font-[600] text-[15px] sm:text-[18px] md:text-[24px]">
          Welcome to RingConnect
          {profile?.firstname && ", " + profile?.firstname}
        </Text>
        <Text className="max-w-[482px] text-[#758599] font-switzer text-[12px] md:text-[14px]">
          Let’s set you up for your first call, follow these quick steps to get
          started.
        </Text>
      </div>

      <div className="border-muted border-[0.5px] customBar h-[333px] overflow-y-auto font-switzer rounded-b-[4px]">
        <div className="flex flex-col px-[16px] sm:px-[24px] py-[30px] h-full justify-between relative">
          {checklist.map((item, index) => (
            <div key={index} className="w-full h-fit flex relative">
              {(item.status === false || item.status === undefined) && (
                <div className="bg-background bg-opacity-50 h-full w-full absolute top-0 left-0 z-10" />
              )}
              {item.isDone ? (
                <div className="mt-[2px] size-[21px] bg-btn rounded-full flex justify-center items-center mr-[4px] sm:mr-[19px]">
                  <CheckIcon className={"text-background size-[10.5px]"} />
                </div>
              ) : (
                <div className="w-[25px] sm:w-[40px] size-[16px] pt-[2px]">
                  <ArrowRight className={"text-[#758599]"} />
                </div>
              )}

              <div className="flex-1 flex justify-between !h-fit">
                <div className="flex flex-col gap-[8px]">
                  <Text
                    className={
                      "font-[500] text-[12px] md:text-[14px] text-primary-dark"
                    }
                  >
                    {item.title}
                  </Text>
                  <Text className="text-[#758599] font-[400] text-[10px] md:text-[12px]">
                    {item.subtitle}
                  </Text>
                </div>
                {!item?.isDone && (
                  <div>
                    <ActionIcon
                      className="!bg-transparent border border-muted rounded-[4px] !px-[10px] md:!px-[16px] !w-fit !h-fit !py-[4px] md:!py-[9px]"
                      onClick={item.buttonAction}
                    >
                      <Text className="text-primary font-[500] text-[10px] md:text-[12px]">
                        {item.buttonText}
                      </Text>
                    </ActionIcon>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
